import Media from "apiEndPoints/Media";
import { Upload } from "components/Antd";
import { ImageElement } from "components/UiElement";
import { useState } from "react";

function Step1Uploader({
  props,
  memorialData,
  subscriptionData,
  setImageSize,
  setCoverImageSize,
}) {
  const [imageUrl, setImageUrl] = useState();
  const [coverUrl, setCoverUrl] = useState();

  return (
    <>
      {" "}
      <div className="stepsContent_profile bg-white">
        <h2 className="fw-semibold">Profile Photo</h2>
        <div className="uploadProfile position-relative">
          {imageUrl || memorialData?.themeOnes?.[0]?.profileImageUrl ? (
            <ImageElement
              previewSource={
                imageUrl || memorialData?.themeOnes?.[0]?.profileImageUrl
              }
              alt="Default-profile"
            />
          ) : (
            <div className="userDefault">
              <ImageElement source="userDefault.png" alt="Default-profile" />
            </div>
          )}
          <Upload
            apiEndPoints={Media.mediaUpload("memorial", "image")}
            name="profileImage"
            type="file"
            setFieldValue={props.handleChange}
            setImageUrl={setImageUrl}
            setImageSize={setImageSize}
            // applyImageCropper
            aspect={0.83}
            validateFileType={["image/jpeg", "image/png", "image/jpg"]}
            validateStatus
            query
            subscriptionData={subscriptionData}
            fileSize
          >
            <em className="icon-camera" />
          </Upload>
        </div>
        <p className="fw-light mb-0 text-center">
          Allowed photo types: png, jpg, jpeg.
        </p>
      </div>
      <div className="customUpload customUpload-icon customUpload-w100 mb-2 mb-lg-0 ">
        <Upload
          name="coverImage"
          setFieldValue={props.handleChange}
          apiEndPoints={Media.mediaUpload("memorial", "image")}
          applyImageCropper
          aspect={3.2}
          aspectSlider
          imageUrl={coverUrl}
          setImageSize={setCoverImageSize}
          setImageUrl={setCoverUrl}
          validateStatus
          query
          subscriptionData={subscriptionData}
          defaultImageUrl={memorialData?.themeOnes?.[0]?.coverImageUrl}
          fileSize
        >
          <div>
            <em className="icon-upload" />
            <span className="d-block">Upload Cover Photo</span>
          </div>
        </Upload>
      </div>
    </>
  );
}

export default Step1Uploader;
